import { createClient } from '@supabase/supabase-js';

// Function to get Firebase ID token safely
const getFirebaseToken = async (): Promise<string | null> => {
    try {
        const { getAuth } = await import('firebase/auth');
        const auth = getAuth();
        return auth.currentUser ? await auth.currentUser.getIdToken() : null;
    } catch (error) {
        console.warn('Could not get Firebase token:', error);
        return null;
    }
};

const supabase = createClient(
    'https://jwuflzmzrxgalgecwgof.supabase.co',
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp3dWZsem16cnhnYWxnZWN3Z29mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgxNjgwMTksImV4cCI6MjA3Mzc0NDAxOX0.EALI6cvHqlRSlFtlaxqgi5iv_nPm3i8dngYjbZ3ZAQU',
    {
        auth: {
            persistSession: false,
            autoRefreshToken: false,
        },
        // Add this debugging to your accessToken function:
        accessToken: async () => {
            console.log('=== Token Debug ===');
            const firebaseToken = await getFirebaseToken();
            console.log('Firebase token:', firebaseToken);
            return firebaseToken;
        },
    }
);

// // Function to inspect table structure and permissions
// const inspectLeadsTable = async () => {
//     try {
//         console.log('Inspecting leads table structure...');

//         // Try to get table information
//         const { data, error } = await supabase
//             .from('leads')
//             .select('*')
//             .limit(1);

//         if (error) {
//             console.error('Table inspection failed:', error);
//             return { success: false, error: error.message, availableFields: [] };
//         }

//         if (data && data.length > 0) {
//             const availableFields = Object.keys(data[0]);
//             console.log('Available fields in leads table:', availableFields);
//             console.log('Sample record structure:', data[0]);
//             return { success: true, error: null, availableFields, sampleRecord: data[0] };
//         } else {
//             console.log('Table is empty or no accessible records');
//             return { success: true, error: 'Table appears empty', availableFields: [] };
//         }
//     } catch (error) {
//         console.error('Exception during table inspection:', error);
//         return { success: false, error: 'Failed to inspect table', availableFields: [] };
//     }
// };

// // Function to fetch 10 leads from the leads table
// const fetchLeads = async () => {
//     try {
//         console.log('Fetching leads from Supabase...');

//         // First, let's try a simple query to test basic connectivity
//         console.log('Testing basic table access...');
//         const { data: testData, error: testError } = await supabase
//             .from('leads')
//             .select('*')
//             .limit(1);

//         if (testError) {
//             console.error('Basic table access failed:', testError);
//             return { success: false, error: `Table access error: ${testError.message}`, data: null };
//         }

//         console.log('Basic table access successful. Sample record:', testData?.[0]);

//         // Now try our specific field query
//         console.log('Fetching specific fields...');
//         const { data, error } = await supabase
//             .from('leads')
//             .select('id, name, email, number, firestore_uuid, company_id, assigned_to, sub_agent_id, created_at')
//             .limit(10)
//             .order('created_at', { ascending: false });

//         if (error) {
//             console.error('Error fetching leads with specific fields:', error);

//             // Fallback: try with minimal fields
//             console.log('Trying fallback query with minimal fields...');
//             const { data: fallbackData, error: fallbackError } = await supabase
//                 .from('leads')
//                 .select('id, name, email')
//                 .limit(10);

//             if (fallbackError) {
//                 console.error('Fallback query also failed:', fallbackError);
//                 return { success: false, error: `Query failed: ${error.message}`, data: null };
//             }

//             console.log('Fallback query successful:', fallbackData);
//             return { success: true, error: 'Used fallback fields', data: fallbackData };
//         }

//         console.log('Successfully fetched leads:', data);
//         return { success: true, error: null, data };
//     } catch (error) {
//         console.error('Exception while fetching leads:', error);
//         return { success: false, error: 'Failed to connect to database', data: null };
//     }
// };

// // Initialize and fetch leads after client setup
// const initializeAndFetchLeads = async () => {
//     console.log('Initializing Supabase client and fetching leads...>>>>>>>>>>>>>>>');
//     console.log('Initializing Supabase client and fetching leads...>>>>>>>>>>>>>>>');

//     try {
//         // Small delay to ensure client is fully initialized
//         await new Promise(resolve => setTimeout(resolve, 100));

//         // First inspect the table structure
//         console.log('Step 1: Inspecting table structure...');
//         console.log('Step 1: Inspecting table structure...');
//         const inspectionResult = await inspectLeadsTable();

//         if (!inspectionResult.success) {
//             console.error('Table inspection failed:', inspectionResult.error);
//             return { success: false, error: `Table inspection failed: ${inspectionResult.error}`, data: null };
//         }

//         console.log('Step 2: Fetching leads...');
//         // Fetch leads
//         const result = await fetchLeads();

//         if (result.success) {
//             console.log(`Fetched ${result.data?.length || 0} leads successfully`);
//         } else {
//             console.warn('Failed to fetch leads:', result.error);
//         }

//         return result;
//     } catch (error) {
//         console.error('Error during initialization:', error);
//         return { success: false, error: 'Initialization failed', data: null };
//     }
// };

// // Auto-fetch leads when the module loads (optional - can be called manually)
// setTimeout(() => {
//     initializeAndFetchLeads();
// },
//     5000);
    
export { supabase };
// export { fetchLeads, initializeAndFetchLeads, inspectLeadsTable };